export const ImpressumResourcesDA = {
  title: "Impressum",
  content: `
    <h2>Kontaktoplysninger</h2>
    <p><strong>Aida Bikic</strong><br>
    Psykolog, forsker og foredragsholder<br>
    Email: <a href="mailto:abikic@icloud.com">abikic@icloud.com</a></p>

    <h2>Ansvar for indhold</h2>
    <p>Indholdet på denne hjemmeside er udarbejdet med største omhu. Dog kan jeg ikke garantere for indholdets nøjagtighed, fuldstændighed eller aktualitet. Jeg forbeholder mig retten til at ændre eller supplere indholdet uden forudgående varsel.</p>

    <h2>Intellektuelle rettigheder</h2>
    <p>Alt indhold på denne hjemmeside, herunder tekster, billeder og andre materialer, er beskyttet af ophavsret. Uautoriseret brug af dette indhold er ikke tilladt.</p>

    <h2>Eksterne links</h2>
    <p>Denne hjemmeside indeholder links til eksterne hjemmesider. Jeg har ingen indflydelse på indholdet af disse hjemmesider og kan ikke påtage mig ansvar for deres indhold.</p>

    <h2>Privatlivspolitik</h2>
    <p>Din privatliv er vigtig for mig. Jeg behandler kun de personlige oplysninger, der er nødvendige for at levere mine tjenester. Du kan altid kontakte mig for at få oplysninger om, hvilke data jeg har om dig.</p>
  `,
};

export const ImpressumResourcesEN = {
  title: "Impressum",
  content: `
    <h2>Contact Information</h2>
    <p><strong>Aida Bikic</strong><br>
    Psychologist, researcher and speaker<br>
    Email: <a href="mailto:abikic@icloud.com">abikic@icloud.com</a></p>

    <h2>Content Responsibility</h2>
    <p>The content on this website has been prepared with the utmost care. However, I cannot guarantee the accuracy, completeness or currency of the content. I reserve the right to change or supplement the content without prior notice.</p>

    <h2>Intellectual Property Rights</h2>
    <p>All content on this website, including texts, images and other materials, is protected by copyright. Unauthorized use of this content is not permitted.</p>

    <h2>External Links</h2>
    <p>This website contains links to external websites. I have no influence on the content of these websites and cannot assume responsibility for their content.</p>

    <h2>Privacy Policy</h2>
    <p>Your privacy is important to me. I only process the personal information that is necessary to deliver my services. You can always contact me to get information about what data I have about you.</p>
  `,
};

export const ImpressumResourcesDE = {
  title: "Impressum",
  content: `
    <h2>Kontaktinformationen</h2>
    <p><strong>Aida Bikic</strong><br>
    Psychologin, Forscherin und Referentin<br>
    Email: <a href="mailto:abikic@icloud.com">abikic@icloud.com</a></p>

    <h2>Inhaltliche Verantwortung</h2>
    <p>Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Ich kann jedoch nicht für die Richtigkeit, Vollständigkeit oder Aktualität der Inhalte garantieren. Ich behalte mir das Recht vor, die Inhalte ohne vorherige Ankündigung zu ändern oder zu ergänzen.</p>

    <h2>Geistige Eigentumsrechte</h2>
    <p>Alle Inhalte dieser Website, einschließlich Texte, Bilder und andere Materialien, sind urheberrechtlich geschützt. Die unbefugte Nutzung dieser Inhalte ist nicht gestattet.</p>

    <h2>Externe Links</h2>
    <p>Diese Website enthält Links zu externen Websites. Ich habe keinen Einfluss auf die Inhalte dieser Websites und kann keine Verantwortung für deren Inhalte übernehmen.</p>

    <h2>Datenschutz</h2>
    <p>Ihre Privatsphäre ist mir wichtig. Ich verarbeite nur die persönlichen Informationen, die für die Erbringung meiner Dienstleistungen erforderlich sind. Sie können mich jederzeit kontaktieren, um Informationen über die Daten zu erhalten, die ich über Sie habe.</p>
  `,
};

export const ImpressumResourcesBS = {
  title: "Impresum",
  content: `
    <h2>Kontakt informacije</h2>
    <p><strong>Aida Bikic</strong><br>
    Psiholog, istraživač i predavač<br>
    Email: <a href="mailto:abikic@icloud.com">abikic@icloud.com</a></p>

    <h2>Odgovornost za sadržaj</h2>
    <p>Sadržaj na ovoj web stranici je pripremljen s najvećom pažnjom. Međutim, ne mogu garantirati tačnost, potpunost ili aktuelnost sadržaja. Zadržavam pravo da promijenim ili dopunim sadržaj bez prethodne najave.</p>

    <h2>Prava intelektualnog vlasništva</h2>
    <p>Sav sadržaj na ovoj web stranici, uključujući tekstove, slike i drugi materijal, zaštićen je autorskim pravima. Neovlašćeno korištenje ovog sadržaja nije dozvoljeno.</p>

    <h2>Eksterni linkovi</h2>
    <p>Ova web stranica sadrži linkove na eksterne web stranice. Nemam uticaj na sadržaj ovih web stranica i ne mogu preuzeti odgovornost za njihov sadržaj.</p>

    <h2>Politika privatnosti</h2>
    <p>Vaša privatnost mi je važna. Obradjujem samo lične informacije koje su neophodne za pružanje mojih usluga. Uvijek me možete kontaktirati da dobijete informacije o tome koje podatke imam o vama.</p>
  `,
};
